
import breakpoints from './utils/breakpoints'
import Spinner from './components/Spinner/Spinner.js';
import BookingFilter from './components/BookingFilter/BookingFilter.js';
import IframeYoutube from './components/IframeYoutube/IframeYoutube'
import IframeVimeo from './components/IframeVimeo/IframeVimeo'
import initMenuMobile from './components/Menu/MenuMobile'
import initMegaMenu from './components/Menu/MegaMenu'
import ToggleElement from './utils/ToggleElement.js'
import { HeaderScroll } from './components/HeaderScroll/HeaderScroll';
import LangChooser from './components/LangChooser/LangChooser.js'
import RoomBookingUrl from './components/RoomBookingUrl/RoomBookingUrl.js'
import Fab from './components/Fab/Fab.js'
import Cursor from './components/Cursor/Cursor.js'
import Hero from './components/Hero/Hero.js'
import Quote from './components/Quote/Quote.js'
import HikingEmbedding from './components/HikingEmbedding/HikingEmbedding'
import FlatpickrInit from './plugins/FlatpickrInit/FlatpickrInit.js'
import UploadHelper from './components/UploadHelper/UploadHelper.js'
import DialogHandler from './components/DialogHandler/DialogHandler'
import OperationRedirect from './components/OperationRedirect/OperationRedirect.js'
import Controls from './components/Controls/Controls.js'
import Webcams from './components/Webcams/Webcams.js'


customElements.define('iframe-youtube', IframeYoutube)
customElements.define('iframe-vimeo', IframeVimeo)


const ToggleTriggers = [...document.querySelectorAll('[data-toggle-trigger]')]
for (let trigger of ToggleTriggers) {
  new ToggleElement(trigger)
}


if (document.getElementById('header')) {
  initMenuMobile({ menuBreakpoint: breakpoints.large })
  initMegaMenu({ largeWidth: breakpoints.large })
  // TODO example of header scroll behaviour

  HeaderScroll()
}



new LangChooser('lang-chooser')


new OperationRedirect({
    currentPath: '/betrieb',
    defaultLang: 'de',
    selectId: 'lang-chooser',
    localStorageKey: 'operationRedirected'
})

new Fab()

new Cursor()

const roomBookingUrls = [...document.querySelectorAll('[data-room-booking-url]')]
for (let roomBookingUrl of roomBookingUrls) {
  new RoomBookingUrl(roomBookingUrl)
}


const heros = [...document.querySelectorAll('.hero')]
for (let hero of heros) {
  new Hero(hero)
}


const quotes = [...document.querySelectorAll('.quote')]
for (let quote of quotes) {
  new Quote(quote)
}

/* Force all info FAQ to be open on large */
const infoAccordions = [...document.querySelectorAll('.accordion.accordion--info .accordion__item, .accordion.accordion--facilities .accordion__item')]
infoAccordions.map(el => {
  if (window.innerWidth >= breakpoints.large) {
    el.open = true
  }
})

const spinnerButtons = [...document.querySelectorAll('[data-spinner-decrease],[data-spinner-increase]')]
for (let spinnerButton of spinnerButtons) {
  new Spinner(spinnerButton)
}

const bookingFilters = [...document.querySelectorAll('[data-booking-filter]')]
for (let bookingFilter of bookingFilters) {
  new BookingFilter(bookingFilter)
}

new FlatpickrInit()

const uploadHelperElements = [...document.querySelectorAll('[data-upload-helper]')];
for (let uploadHelperElement of uploadHelperElements) {
  new UploadHelper(uploadHelperElement)
}

new HikingEmbedding()

new DialogHandler()

new Webcams()

new Controls()
